<template>
  <div v-resize="onResize" :ref="id" style="height: 100%;"></div>
</template>

<script>
import echarts from 'echarts'
  export default {
    name: "et-charts",
    computed: {
      options() {
        return this.option
      },
    },
    props: {
      option: Object
    },
    data() {
      return {
        id:new Date().getTime(),
        charts:{}
      }
    },
    methods:{
      onResize(){
        if(this.charts.resize)
        this.charts.resize();
      }
    },
    mounted() {
      setTimeout(()=>{
        this.charts = echarts.init(this.$refs[this.id])
        this.charts.setOption(this.options)
      },200)
    },
    watch: {
      options() {
        this.charts.setOption(this.options)
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/charts/ETCharts.vue